// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._34-YfpxYgBSfravP3h60-F {\n  margin-bottom: 20px;\n}\n\n.huwvhrAX1_lzy3wrhf_QX {\n  font-weight: 800;\n  border-bottom: 1px solid #e0e0e0;\n  /* cancel out bs3's row class's margining */\n  margin: 0 29px 0 29px !important;\n}\n\n._3JPbVAHxK3iqOZCqO2nQVp {\n  border-bottom: 1px solid #e0e0e0;\n  padding: 7px 0 7px 0;\n  /* cancel out bs3's row class's margining */\n  margin: 0 15px 0 15px !important;\n}\n\n._1he08VUpW3GUtI2wvrAyn3 {\n  max-width: 800px;\n}\n\n._3Q1QpGdTxojI4gLIoY6mo9 {\n  margin-bottom: 30px;\n}\n\n.QoM8x5S1bXGONsCDqiVk1 {\n  margin-bottom: 12px;\n}\n\n._3i0rkRFqoFXwhnNPDVBqx0 {\n  font-weight: 800;\n}\n\n._1F6Pm8IrxYyMYG3UkhQV1Z {\n  border-bottom: 1px solid #e0e0e0;\n  /* cancel out bs3's row class's margining */\n  margin: 0 15px 0 15px !important;\n}", ""]);
// Exports
exports.locals = {
	"heading": "_34-YfpxYgBSfravP3h60-F",
	"tableHeading": "huwvhrAX1_lzy3wrhf_QX",
	"tableRow": "_3JPbVAHxK3iqOZCqO2nQVp",
	"formWidth": "_1he08VUpW3GUtI2wvrAyn3",
	"formBottom": "_3Q1QpGdTxojI4gLIoY6mo9",
	"sendMessageSubject": "QoM8x5S1bXGONsCDqiVk1",
	"userTableHeading": "_3i0rkRFqoFXwhnNPDVBqx0",
	"userTableHeaderUnderline": "_1F6Pm8IrxYyMYG3UkhQV1Z"
};
module.exports = exports;
